import type { PurchasesPullPayload } from './purchasesPullRemote';

export type WebPurchasesSnapshotCache = PurchasesPullPayload & {
  fetchedAt: number;
};

let cached: WebPurchasesSnapshotCache | null = null;

export function setWebPurchasesSnapshotCache(payload: PurchasesPullPayload): void {
  cached = {
    purchaseOrders: Array.isArray(payload.purchaseOrders) ? payload.purchaseOrders : [],
    purchaseOrderItems: Array.isArray(payload.purchaseOrderItems) ? payload.purchaseOrderItems : [],
    receptions: Array.isArray(payload.receptions) ? payload.receptions : [],
    receptionItems: Array.isArray(payload.receptionItems) ? payload.receptionItems : [],
    returns: Array.isArray(payload.returns) ? payload.returns : [],
    returnItems: Array.isArray(payload.returnItems) ? payload.returnItems : [],
    fetchedAt: Date.now(),
  };
}

export function getWebPurchasesSnapshotCache(): WebPurchasesSnapshotCache | null {
  return cached;
}
